export default __webpack_public_path__ + "locales/ro/SharingPanel.json?hash=4675a975202a6fdfc99e5faded37065e";